import { useTranslation } from 'react-i18next';
import { PropsWithChildren } from 'react';
import { Group, Title, Stack } from '@mantine/core';
import { InfoIcon } from 'components/InfoIcon';

interface PaperHeaderProps extends PropsWithChildren {
  titleKey: string;
  iconKey?: string;
}

export const PaperHeader = (props: PaperHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Group justify={'space-between'}>
      <Stack gap={'xs'}>
        <Title order={4}>{t(props.titleKey)}</Title>
      </Stack>
      <Group>
        {props.children}
        {props.iconKey && <InfoIcon i18nKey={props.iconKey} />}
      </Group>
    </Group>
  );
};
